import React from 'react'
import { CaptionLight } from '../../../components'

export const MediaTypesTableHead = () => (
  <thead>
    <tr>
      <th />
      <th>
        <CaptionLight>Title</CaptionLight>
      </th>
      <th>
        <CaptionLight>Content Type</CaptionLight>
      </th>
      <th>
        <CaptionLight>Extension</CaptionLight>
      </th>
      <th>
        <CaptionLight>Mime Type</CaptionLight>
      </th>
    </tr>
  </thead>
)
